module.exports = __webpack_public_path__ + "static/media/fte-sweat-program-thumbnail.d59d1b89.png";